module.exports = __webpack_public_path__ + "img/posterSearch-des7.c9df30e4.png";